<template>
  <table-list
    idKey="id"
    :listConfig="listConfig"
    :apis="apis"
    :createFrom="fromConfig"
    :btn-config="btnConfig"
    @handleBtn="handleBtn"
    :btnConfig="btnConfig | filterBtnsRole($route)"
  />
</template>

<script>
import config from "./config/announce.config";
export default {
  data() {
    return {
      ...config(),
    };
  },
  methods: {
    handleBtn() {
      
    }
  }
};
</script>
